// extracted by mini-css-extract-plugin
export var contentBody = "_dp-9";
export var headerImage = "_dp-2";
export var imageButton = "_dp-7";
export var imageButtonIcon = "_dp-8";
export var imageHeader = "_dp-4";
export var imageHeaderText = "_dp-5";
export var imageOverlay = "_dp-3";
export var imageTitle = "_dp-6";
export var imageWrapper = "_dp-1";
export var taskList = "_dp-a";
export var widget = "_dp-0";